import Api from '@/api'

export default {
  props: ['project'],
  computed: {
    mergedProjectData() {
      if (this.projectFields && this.project.fields) {
        let newFields = this.projectFields.map((d)=>{
          let candidate = this.project.fields.find((dd)=>dd.id === d.id)
          if(!candidate) candidate = JSON.parse(JSON.stringify(d))
          else if(!candidate.view) candidate.view = d.view
          return candidate
        })
        this.project.fields = newFields
        return this.project
      }
      return null
    },
    nonEmptyFields(){
      return this.mergedProjectData?this.mergedProjectData.fields.filter((d)=>d.value && d.value[0] && d.value[0]!==''):[]
    },
    relevantFields(){
      return this.nonEmptyFields.slice(0,2) //??
    },
    projectFields () {
      return this.$store.state.projectFields.data
    }
  },
  // asyncComputed: {
  //   projectFields () {
  //     return Api.getProjectFields()
  //   }
  // },
}